import { render } from "./InfoAdvantages.vue?vue&type=template&id=3324d23b&scoped=true"
import script from "./InfoAdvantages.vue?vue&type=script&lang=js"
export * from "./InfoAdvantages.vue?vue&type=script&lang=js"

import "./InfoAdvantages.vue?vue&type=style&index=0&id=3324d23b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3324d23b"]])

export default __exports__